import { SignedUploadResponse } from "@coaching-culture/types";
import axios from "axios";
import React, { useRef, useState } from "react";
import styled from "styled-components";
import Button from "./Button";
import Flex from "./Flex";
import { postToSignedUpload, uploadErrorMessage } from "../uploads";

const Container = styled.div<any>`
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding: 6px 12px;
  margin-right: 6px;
`;

type NewUploaderProps = {
  onChange: (value: SignedUploadResponse) => void;
};

export const NewFileUploader = ({ onChange }: NewUploaderProps) => {
  const fileRef = useRef<HTMLInputElement>(null);
  const [filename, setFilename] = useState("");
  const [uploadProgress, setUploadProgress] = useState<number | null>(null);

  const uploadImage = async () => {
    const file = (fileRef?.current?.files || [])[0];

    if (file == null) {
      return;
    }

    setUploadProgress(0);

    try {
      const res = await axios.post<SignedUploadResponse>("/api/v2/upload", {
        originalFilename: file.name,
      });
      await postToSignedUpload(res.data.upload, file, setUploadProgress);
      setFilename(file.name);
      onChange(res.data);
    } catch (err) {
      alert(uploadErrorMessage(err));
    } finally {
      setUploadProgress(null);
    }
  };

  const startUpload = () => {
    fileRef.current?.click();
  };

  return (
    <Flex>
      <input
        type="file"
        ref={fileRef}
        style={{ display: "none" }}
        onChange={uploadImage}
      />
      <Container>
        {uploadProgress != null
          ? `Uploading ${uploadProgress}%`
          : filename || "No File Uploaded"}
      </Container>
      <Button onClick={startUpload} type="button">
        Browse
      </Button>
    </Flex>
  );
};
